






import Vue from 'vue'

export default Vue.extend({
  name: 'FeedbackMessage',
  props: {
    errorMessage: String
  }
})
